export default "__VITE_ASSET__ced31455__"